<template>
  <AtomsCalculatorFrame
    iframe-class="!mx-auto"
    :type="type"
    :src="src"
  />
</template>

<script>
export default {
  name: 'MoleculesCalculatorBuyingCosts',

  data: () => ({
    type: 'Property_Buying_Cost_Calculator',
    src: '//www.visionabacus.net/Tools/B3/SuiteA/A400/Property_Buying_Cost_Calculator/CompareClub'
  })
}
</script>
